import React from 'react';
import { Truck, CheckCircle, Clock, XCircle, Package } from 'lucide-react';
import ViewLayout from '../ui/ViewLayout';

const TransfersView = ({ transferRequests }) => {
  // Calculate transfer statistics
  const pendingTransfers = transferRequests.filter(t => t.status === 'pending').length;
  const approvedTransfers = transferRequests.filter(t => t.status === 'approved').length;
  const rejectedTransfers = transferRequests.filter(t => t.status === 'rejected').length;
  const completedTransfers = transferRequests.filter(t => t.status === 'completed').length;

  const stats = [
    <ViewLayout.Stat 
      title="Total Requests" 
      value={transferRequests.length} 
      icon={Truck} 
      color="blue" 
    />,
    <ViewLayout.Stat 
      title="Pending" 
      value={pendingTransfers} 
      icon={Clock} 
      color="orange" 
    />,
    <ViewLayout.Stat 
      title="Approved" 
      value={approvedTransfers} 
      icon={CheckCircle} 
      color="green" 
    />,
    <ViewLayout.Stat 
      title="Completed" 
      value={completedTransfers} 
      icon={Package} 
      color="purple" 
    />
  ];

  return (
    <ViewLayout
      title="Transfer Requests"
      subtitle="Manage prop transfers between organizations"
      stats={stats}
    >
      <div className="bg-white rounded-lg shadow-md">
        <div className="p-4 border-b">
          <h3 className="font-semibold">All Transfer Requests</h3>
        </div>
        <div className="overflow-x-auto">
          {transferRequests.length > 0 ? (
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left p-4 font-medium">Prop</th>
                  <th className="text-left p-4 font-medium">From</th>
                  <th className="text-left p-4 font-medium">To</th>
                  <th className="text-left p-4 font-medium">Status</th>
                  <th className="text-left p-4 font-medium">Date</th>
                </tr>
              </thead>
              <tbody>
                {transferRequests.map(transfer => (
                  <tr key={transfer.id} className="border-b hover:bg-gray-50">
                    <td className="p-4">
                      <div className="font-medium">{transfer.prop?.name || 'Unknown Prop'}</div>
                      <div className="text-sm text-gray-600">{transfer.prop?.category}</div>
                    </td>
                    <td className="p-4 text-sm">{transfer.from_org?.name}</td>
                    <td className="p-4 text-sm">{transfer.to_org?.name}</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        transfer.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                        transfer.status === 'approved' ? 'bg-green-100 text-green-800' :
                        transfer.status === 'rejected' ? 'bg-red-100 text-red-800' :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {transfer.status}
                      </span>
                    </td>
                    <td className="p-4 text-sm">{new Date(transfer.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <Truck className="h-12 w-12 mx-auto mb-3 opacity-50" />
              <p>No transfer requests found</p>
              <p className="text-sm mt-2">Transfer requests will appear here once submitted</p>
            </div>
          )}
        </div>
      </div>
    </ViewLayout>
  );
};

export default TransfersView;